import { useState } from "react";
import { API_CALLS } from "../../../../../API/api_calls";
import { API_STATUS } from "../../../../../redux/common";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import Upload from "../../upload";
import { useFindContent } from "../../useFindContent";
import { ContentProps } from "../Content";
import { MaxWidthContainer } from "../style";
import VideoCreate from "./VideoCreate";
import VideoPreview from "./VideoPreview";

const Video = ({ id }: ContentProps.CommonProps) => {
  const { content_data, content_id } = useFindContent(
    id
  ) as ArticleProps.WithVideoContent;
  const { video_path, title, description, post_id } = content_data;
  const [isVideoCreated, setIsVideoCreated] = useState(
    video_path && title && description ? true : false
  );
  const [uploadVideoAPI_STATUS, setUploadVideoAPI_STATUS] =
    useState<API_STATUS>("idle");

  const onDeleteVideo = () => {
    API_CALLS.ARTICLE.deleteASingleArticleContent(id);
    video_path &&
      API_CALLS.ARTICLE.deleteVideoFromAArticle({
        post_id,
        content_id,
      });
  };

  return video_path ? (
    <MaxWidthContainer>
      {isVideoCreated ? (
        <VideoPreview
          id={id}
          setIsVideoCreated={setIsVideoCreated}
          onDeleteVideo={onDeleteVideo}
        />
      ) : (
        <VideoCreate
          id={id}
          setIsVideoCreated={setIsVideoCreated}
          onDeleteVideo={onDeleteVideo}
        />
      )}
    </MaxWidthContainer>
  ) : (
    <Upload
      iconType="VideoNew"
      onClose={onDeleteVideo}
      title="Add a video"
      fileType="video"
      isUploading={uploadVideoAPI_STATUS === "progress"}
      onUpload={(e) => {
        const files = e.target.files;
        if (files?.length) {
          API_CALLS.ARTICLE.uploadVideoForArticleDraft(
            {
              content_id,
              post_id,
              video: files[0],
            },
            setUploadVideoAPI_STATUS
          );
        }
      }}
      onDrop={(e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (!files.length) return;
        if (files[0].type.includes("video")) {
          API_CALLS.ARTICLE.uploadVideoForArticleDraft(
            {
              content_id,
              post_id,
              video: files[0],
            },
            setUploadVideoAPI_STATUS
          );
        }
      }}
    />
  );
};

export default Video;
